/** @jsxImportSource @emotion/react */
import { Button, Container, Stack, Text } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";
import { ReactNode } from "react";
import {
  ErrorBoundary as ReactErrorBoundary,
  ErrorBoundaryPropsWithRender,
  FallbackProps,
} from "react-error-boundary";

export const ErrorBoundaryComponent = ({
  resetErrorBoundary,
}: FallbackProps) => (
  <Container bg="grey.t05" padding="12">
    <Stack align="center" gap="4">
      <SvgInline name="info" width="100" height="100" />
      <Text as="h2" textStyle="heading5">
        Aah! Something went wrong
      </Text>
      <Text>
        We have experienced an issue loading this content. Please refresh the
        page or try again.
      </Text>
      <Button onClick={resetErrorBoundary}>Try again</Button>
    </Stack>
  </Container>
);

interface Props extends ErrorBoundaryPropsWithRender {
  children: ReactNode;
}
export const ErrorBoundary = ({ children, ...rest }: Props) => (
  <ReactErrorBoundary {...rest} fallbackRender={ErrorBoundaryComponent}>
    {children}
  </ReactErrorBoundary>
);
